import { CodeDescription, getError } from '@aslanpay/portal-common-lib';

/**
 * What to tell somebody whose publish or withdraw was refused, by the reason the service gave.
 * <p>
 * The service names every refusal with a code of its own, so the page can say what to do about it rather than
 * repeat the sentence it was handed. A code nobody has written words for falls back to that sentence, which is
 * always in plain English, so a new refusal reads sensibly before anyone touches this.
 */
const ADVICE: Partial<Record<CodeDescription, string>> = {
  CMP_NOT_A_DRAFT: 'This campaign has already been published, so there is nothing to publish.',
  CMP_ALREADY_OPENED:
    'Nominations have already opened, so this cannot go back to a draft. Cancel it instead.',
  CMP_NOT_READY_TO_PUBLISH:
    'Something the campaign needs is missing or out of date. Open Edit to put it right — an opening date that has since passed is the usual reason.',
  CMP_ALREADY_AT_STATUS: 'The campaign is already at that status.',
  CMP_STATE_MOVE_NOT_ALLOWED:
    'The campaign has moved on since this page was loaded. Reload it and try again.',
};

/** Why the move was refused, in words that say what to do about it. */
export const stateMoveProblem = (error: Error) => {
  const { codeDescription, message } = getError(error);

  return (
    (codeDescription && ADVICE[codeDescription]) ||
    message ||
    'Nothing was changed. Please try again.'
  );
};
